module.exports = __webpack_public_path__ + "img/iron-on-2.19e8e02d.jpg";